(function () {
  let isMobile = setIsMobile(window.innerWidth);

  function setIsMobile(width) {
    return width < 1200;
  }

  window.addEventListener('resize', function () {
    isMobile = setIsMobile(window.innerWidth);
  });

  //Get titles for second level menu
  const menuItemsWithChildren = document.querySelectorAll('#primary-menu > li.menu-item-has-children');

  if (menuItemsWithChildren.length > 0) {
    menuItemsWithChildren.forEach(function (menuItem) {
      const secondLevelSubMenu = menuItem.querySelector('ul');

      if (secondLevelSubMenu) {
        secondLevelSubMenu.style.setProperty("--title", '"' + menuItem.querySelector('a').textContent + '"');
      }
    });
  }

  //Get titles for third level menu
  const subMenuLinks = document.querySelectorAll('#primary-menu .menu-item-has-children > .sub-menu .menu-item-has-children > a');

  if (subMenuLinks.length > 0) {
    subMenuLinks.forEach(function (link) {
      const nextUl = link.nextElementSibling;

      if (nextUl && nextUl.tagName === 'UL') {
        nextUl.style.setProperty("--title", '"' + link.textContent + '"');
      }
    });
  }

  //Mobile menu
  // Add sub levels artifacts
  const menu = document.getElementById('primary-menu');

  if (menu) {
    const subMenus = menu.querySelectorAll('.sub-menu');

    subMenus.forEach(function (subMenu) {
      const backBtn = document.createElement('li');

      backBtn.className = 'menu-back-btn';
      backBtn.textContent = 'Tilbake';

      backBtn.addEventListener('click', function () {
        window.setTimeout(function () {
          // Add delay to animate.
          const openedItems = menu.querySelectorAll('li.sub-menu-opened');
          if (openedItems.length > 0) {
            openedItems[openedItems.length - 1].classList.remove('sub-menu-opened');
          }
        }, 300);

        const menuParent = menu.parentElement;
        if (menuParent.classList.contains('show-level-3')) {
          menuParent.classList.remove('show-level-3');
        } else {
          menuParent.classList.remove('show-level-2');
        }
      });

      subMenu.insertBefore(backBtn, subMenu.firstChild);
    });

    // Navigation to second level
    const secondLevelLinks = menu.querySelectorAll('.menu-item-has-children > a');

    secondLevelLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (isMobile) {
          event.preventDefault();
          link.parentElement.classList.add('sub-menu-opened');
          menu.parentElement.classList.add('show-level-2');
        }
      });
    });

    // Navigation to third level
    const thirdLevelLinks = menu.querySelectorAll('.menu-item-has-children > .sub-menu .menu-item-has-children > a');

    thirdLevelLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (isMobile) {
          event.preventDefault();
          link.parentElement.classList.add('sub-menu-opened');
          menu.parentElement.classList.add('show-level-3');
        }
      });
    });
  }

  const navbarToggler = document.querySelector('.navbar-toggler');

  if (navbarToggler) {
    navbarToggler.addEventListener('click', function (event) {
      event.preventDefault();
      document.body.classList.toggle('menu-open');
      document.querySelectorAll('.menu-back-btn').forEach(function (btn) {
        btn.click();
      });
    });
  }
})();
